import React, { useEffect, useRef } from 'react';
import { useElementsCoordsContext } from '@hooks';
import TopRecommendBanner from '../TopRecommendBanner/TopRecommendBanner';
import { useStyles } from './styles';

const SubMenuGroupRecommend = ({
  section,
  setSubMenuCoordsList,
  topBannerText,
}) => {
  const classes = useStyles();
  const ref = useRef();
  const refTopBanner = useRef();
  const { elementsCoords } = useElementsCoordsContext();

  useEffect(() => {
    const heightsFixedElements = Object.values(elementsCoords).reduce(
      (acc, item) => (acc += item.height),
      0,
    );

    setSubMenuCoordsList(prevState => {
      const currentSubMenuAlreadyExist = prevState.find(
        itm => itm.id === section.id,
      );

      if (currentSubMenuAlreadyExist) return prevState;

      return [
        ...prevState,
        {
          id: section.id,
          start:
            ref.current.getBoundingClientRect().top -
            heightsFixedElements +
            refTopBanner.current.getBoundingClientRect().height,
          end:
            ref.current.getBoundingClientRect().top +
            ref.current.getBoundingClientRect().height -
            150,
        },
      ];
    });
    // eslint-disable-next-line
  }, []);

  return (
    <div
      ref={ref}
      key={section.name}
      id={section.name}
      className={classes.container}
    >
      <div>
        <div ref={refTopBanner}>
          <TopRecommendBanner topBannerText={topBannerText} />
        </div>
      </div>
    </div>
  );
};

export default SubMenuGroupRecommend;
